import { googleRecaptchaSiteKeyUK } from '../Environment/Variables';

export const loadGoogleRecaptcha = () => {
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      const head = document.getElementsByTagName('head')[0];
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://www.google.com/recaptcha/api.js?render=${googleRecaptchaSiteKeyUK}`;

      script.onload = () => {
        resolve('Google ReCaptcha loaded successfully');
      };

      script.onerror = () => {
        reject('Error: Unable to load Google ReCaptcha script');
      };
      head.appendChild(script);
    } else {
      resolve('success');
    }
  });
};

export const getReCaptchaToken = (action: string) => {
  return new Promise(res => {
    const { grecaptcha }: any = window;
    if (grecaptcha) {
      grecaptcha.ready(async () => {
        try {
          const token = await grecaptcha.execute(googleRecaptchaSiteKeyUK, { action });
          return res(token);
        } catch (_err) {
          return res('');
        }
      });
    } else {
      return res('');
    }
  });
};
